export default function domainUrlReplace(value: string) {
  const siteDomain = `${process.env["NEXT_PUBLIC_SITE_URL"]}`;
  const wordpressDomains = [
    "https://ripleyprd.wpengine.com",
    "https://ripley1stg.wpengine.com",
    "https://ripley1stg.wpenginepowered.com",
  ];

  if (!value) return value;

  let result = value;

  // Find the matching domain
  const matchingDomain = wordpressDomains.find((domain) =>
    result.includes(domain)
  );

  if (!matchingDomain) {
    return value;
  }

  // Special case for wp-content URLs
  const wpContentRegex = new RegExp(`${matchingDomain}/wp-content`, "g");
  result = result.replace(wpContentRegex, siteDomain);

  // Replace all occurrences of the domain
  const regex = new RegExp(
    matchingDomain.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
    "g"
  );
  result = result.replace(regex, siteDomain);

  return result;
}
